import type { RegisteredComponent } from "@builder.io/sdk-react";

import {
  ContactDetailsComponent,
  FindStoreBannerComponent,
  SubscribeFormComponent,
} from "@/components/Footer/components";

export const footerCustomComponents: RegisteredComponent[] = [
  ContactDetailsComponent,
  FindStoreBannerComponent,
  SubscribeFormComponent,
];
